import styled from 'styled-components'
import { Info, Trash } from 'react-feather'
import { ButtonMui } from 'src/components/ButtonMui'

export const Wrapper = styled.div`
    padding: 1rem 0.6rem;
    width: 100%;
`
export const InfoButton = styled(Info)`
    cursor: pointer;
    color: blue;
`

export const CancelInventoryButton = styled(Trash)`
    cursor: pointer;
    color: red;
`

export const CustomButton = styled(ButtonMui)`
    width: 5.5rem;
    height: 1.8rem;
`
